@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    <ix-layout-grid class="content flex-wrap flex-row px-0" columns="12">
      <ix-row class="px-0">
        <ix-col class="px-0 py-0 d-flex" size="12">
          <ix-input
            #documentInput
            (input)="validateImageUrl(documentInput.value)"
            (change)="validateImageUrl(documentInput.value)"
            [formControl]="control"
            [invalidText]="createInvalidText(control)"
            [ngClass]="{'ix-invalid': control.errors}"
            class="w-100 pe-2"
            id="{{attribute.name}}">
            <ix-icon name="globe" size="16" slot="start"></ix-icon>
          </ix-input>
          @if (validatedImageUrl) {
            <a [href]="validatedImageUrl"
              rel="noopener noreferrer"
              target="_blank">
              <div
                [ngStyle]="{ 'background-image': 'url(' + validatedImageUrl + ')' }"
              class="document-image"></div>
            </a>
          }
          @if (!validatedImageUrl) {
            <a
              [attr.href]="documentInput.value ? documentInput.value : null"
              rel="noopener noreferrer"
              target="_blank">
              <ix-icon-button [disabled]="documentInput.value ===''"
              icon="open-external" variant="subtle-primary"></ix-icon-button>
            </a>
          }
        </ix-col>
      </ix-row>
    </ix-layout-grid>
  </div>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
